<ng-container *ngIf="viewConfig.loading">
  <app-spinner-fullscreen></app-spinner-fullscreen>
</ng-container>
<div class="ind-page-title">
  <div class="row px-4">
    <div class="col-12">
      <div class="input-group ind-input-group" [ngClass]="searchBoxClass">
        <span
          class="input-group-text border-end-0 rounded-start-4"
          id="basic-addon1"
        >
          <img
            alt="Search icon"
            class="icon"
            src="/icons/linear/search-normal-outline.svg"
          />
        </span>

        <span class="input-group-text p-0" id="filter-dropdown-wrapper">
          <div class="dropdown filter-dropdown">
            <button
              class="btn btn-link dropdown-toggle filter-dropdown-toggle"
              type="button"
              id="filterSearchDropdown"
              data-bs-toggle="dropdown"
              data-bs-display="static"
              aria-expanded="false"
              aria-haspopup="menu"
              aria-controls="filterSearchDropdownMenu"
              aria-label="Filter search options"
              (keydown)="onFilterSearchDropdownKeydown($event)"
            ></button>
            <ul
              id="filterSearchDropdownMenu"
              class="dropdown-menu dropdown-menu-start"
              aria-labelledby="filterSearchDropdown"
            >
              <li>
                <button
                  type="button"
                  class="dropdown-item"
                  [attr.aria-posinset]="1"
                  [attr.aria-setsize]="2"
                  (click)="useFilterSeach()"
                  (keydown.enter)="useFilterSeach()"
                  (keydown.space)="useFilterSeach()"
                >
                  Filter Search
                </button>
              </li>
              <li>
                <button
                  type="button"
                  class="dropdown-item"
                  [attr.aria-posinset]="2"
                  [attr.aria-setsize]="2"
                  (click)="useSemanticSearch()"
                  (keydown.enter)="useSemanticSearch()"
                  (keydown.space)="useSemanticSearch()"
                >
                  Semantic Search
                </button>
              </li>
            </ul>
          </div>
        </span>

        <input
          (focus)="highlightSearchBox('focus')"
          (blur)="highlightSearchBox('blur')"
          aria-label="Search Documents"
          [(ngModel)]="searchValue"
          (input)="onFilterDocuments($event)"
          type="text"
          class="form-control pt-3 pb-3 border-start-0"
          [placeholder]="searchPlaceholder"
          aria-describedby="basic-addon1"
        />
        <span class="input-group-text rounded-end-4 p-0" id="basic-addon2">
          <button
            type="button"
            class="btn-clear-search"
            aria-label="Clear search"
            (click)="clearGenAiSearch()"
            (keydown.enter)="clearGenAiSearch()"
            (keydown.space)="clearGenAiSearch()"
          >
            <img
              src="img/close-circle-outline.png"
              alt="search icon"
            />
          </button>
        </span>
      </div>
    </div>
  </div>
</div>
<div class="summary-container" *ngIf="isGenerativeSearch">
  <div class="summary-header">
    <span class="sparkle-icon">✨</span>
    <h2>Generative AI Summary:</h2>
  </div>
  <small *ngIf="allGenDocuments.length"
    ><b
      >The summary is generated by AI. Please confirm high priority items by
      manually searching the documents below.</b
    ></small
  >
  <p>{{ summary }}</p>
  <small *ngIf="allGenDocuments.length"
    ><b>Here's more detailed breakdown:</b></small
  >
  <div class="document-item" *ngFor="let doc of allGenDocuments; let i = index">
    <ng-container>
      <p>
        <strong>{{ doc.documentName }}</strong>
      </p>
      <p>{{ splitContent(doc.content) }}</p>
      <p>
        <a (click)="goToDocumentAI(doc)"
        (keydown.enter)="goToDocumentAI(doc)"
        (keydown.space)="goToDocumentAI(doc)"
          >The document is on page {{ doc.pageNumber }}.</a
        >
      </p>
    </ng-container>
  </div>
  <div>
    <div>
      <button
        (click)="goNextGenAIDocuments()"
        (keydown.enter)="goNextGenAIDocuments()"
        (keydown.space)="goNextGenAIDocuments()"
        *ngIf="nextPageToken"
        class="show-more-button"
      >
        Show More...
      </button>
    </div>
  </div>
</div>
<div *ngIf="!isGenerativeSearch && isFilterSearch">
  <div class="search-container p-0">
    <div ngbAccordion>
      <div ngbAccordionItem [collapsed]="false">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Search Documents</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <div class="col-12 m-0 p-0">
                <form
                  [ngClass]="{ disabled: searchValue }"
                  [formGroup]="searchForm"
                  class="m-0 pb-4 row ind-search-filters"
                >
                  <div class="col-12 m-0 p-0">
                    <div class="row m-0 align-items-baseline">
                      <div class="px-1 ps-0 col pt-1">
                        <app-custom-dropdown
                          [defaultWidth]="false"
                          label="Divisions"
                          [multiple]="true"
                          [control]="getControl('documentCategory')"
                          [options]="documentDivisions"
                        ></app-custom-dropdown>
                      </div>

                      <ng-container
                        *ngFor="
                          let inputField of selectedFilledFilters;
                          trackBy: trackInput
                        "
                      >
                        <div
                          class="px-1 col pt-1"
                          *ngIf="inputField.type !== 'range'"
                        >
                          <label
                            for="{{ inputField.label }}"
                            class="form-label"
                            *ngIf="inputField.type !== 'multiselect'"
                            >{{ inputField.label }}</label
                          >
                          <input
                            type="{{ inputField.type }}"
                            formControlName="{{ inputField.formControlName }}"
                            id="{{ inputField.label }}"
                            class="form-control"
                            [attr.aria-label]="inputField.label"
                            [max]="today"
                            *ngIf="
                              inputField.type === 'text' ||
                              inputField.type === 'date'
                            "
                          />
                          <select
                            class="form-control select"
                            [formControlName]="inputField.formControlName"
                            *ngIf="inputField.type === 'state'"
                          >
                            <option hidden></option>
                            <option
                              *ngFor="let state of states"
                              [value]="state"
                            >
                              {{ state }}
                            </option>
                          </select>
                          <select
                            class="form-control select"
                            [formControlName]="inputField.formControlName"
                            *ngIf="inputField.type === 'dealerType'"
                          >
                            <option hidden></option>
                            <option
                              *ngFor="let dealerType of dealerTypes"
                              [value]="dealerType"
                            >
                              {{ dealerType }}
                            </option>
                          </select>
                          <app-custom-dropdown
                            *ngIf="inputField.type === 'multiselect'"
                            [defaultWidth]="false"
                            label="Document Type"
                            [multiple]="true"
                            [control]="getControl('documentType')"
                            [options]="documentTypes"
                          ></app-custom-dropdown>
                        </div>
                        <div
                          class="d-flex date-range pt-1 px-1"
                          *ngIf="inputField.type === 'range'"
                        >
                          <ng-container
                            *ngIf="inputField.label === 'Date of Filing Range'"
                          >
                            <div class="d-block">
                              <label for="filingStartDate" class="form-label"
                                >Filing Date Start</label
                              >
                              <input
                                type="date"
                                [max]="today"
                                formControlName="filingStartDate"
                                id="filingStartDate"
                                class="form-control"
                                aria-label="Filing Date Start"
                              />
                            </div>
                            <p class="pe-1 ps-1">-</p>
                            <div class="d-block">
                              <label for="filingEndDate" class="form-label"
                                >Filing Date End</label
                              >
                              <input
                                type="date"
                                [max]="today"
                                formControlName="filingEndDate"
                                id="filingEndDate"
                                class="form-control"
                                aria-label="Filing Date End"
                              />
                            </div>
                          </ng-container>
                          <ng-container
                            *ngIf="inputField.label === 'Expiration Date Range'"
                          >
                            <div class="d-block">
                              <label
                                for="expirationStartDate"
                                class="form-label"
                                >Expiration Date Start</label
                              >
                              <input
                                type="date"
                                [max]="today"
                                formControlName="expirationStartDate"
                                id="expirationStartDate"
                                class="form-control"
                                aria-label="Expiration Date Start"
                              />
                            </div>
                            <p class="pe-1 ps-1">-</p>
                            <div class="d-block">
                              <label for="expirationEndDate" class="form-label"
                                >Expiration Date End</label
                              >
                              <input
                                type="date"
                                [max]="today"
                                formControlName="expirationEndDate"
                                id="expirationEndDate"
                                class="form-control"
                                aria-label="Expiration Date End"
                              />
                            </div>
                          </ng-container>
                          <ng-container
                            *ngIf="inputField.label === 'Issue Date Range'"
                          >
                            <div class="d-block col-5">
                              <label for="issueStartDate" class="form-label"
                                >Issue Date Start</label
                              >
                              <input
                                type="date"
                                [max]="today"
                                formControlName="issueStartDate"
                                id="issueStartDate"
                                class="form-control"
                                aria-label="Issue Date Start"
                              />
                            </div>
                            <p class="pe-1 ps-1">-</p>
                            <div class="d-block col-5">
                              <label for="issueEndDate" class="form-label"
                                >Issue Date End</label
                              >
                              <input
                                type="date"
                                [max]="today"
                                formControlName="issueEndDate"
                                id="issueEndDate"
                                class="form-control"
                                aria-label="Issue Date End"
                              />
                            </div>
                          </ng-container>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </form>
                <div>
                  <!-- @if (!isMultipleDivisionSelected) { -->
                  <app-button
                    class="filter ind-button-md"
                    type="outline-dark"
                    label="Add Filters"
                    (click)="addFilters()"
                    (keydown.enter)="addFilters()"
                    (keydown.space)="addFilters()"
                    [attr.aria-label]="'Add more filters'"
                  ></app-button>
                  <!-- } -->
                  <app-button
                    class="filter ind-button-md"
                    type="outline-dark"
                    label="Clear Filter"
                    (click)="clearFilter()"
                    (keydown.enter)="clearFilter()"
                    (keydown.space)="clearFilter()"
                    [attr.aria-label]="'Clear Filters'"
                  ></app-button>
                  <app-button
                    class="ind-button-md primary"
                    type="primary"
                    label="Search"
                    (click)="onSearch()"
                    (keydown.enter)="onSearch()"
                    (keydown.space)="onSearch()"
                    [attr.aria-label]="'Search documents'"
                    [disabled]="disableSearchButton"
                  ></app-button>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row px-4 m-0">
    <div class="col-12 m-0 p-0">
      <ng-container *ngIf="viewConfig.error">
        <ngb-alert
          (closed)="viewConfig.setDefault()"
          type="danger"
          [attr.aria-live]="'assertive'"
        >
          {{ viewConfig.error }}
        </ngb-alert>
      </ng-container>

      <ng-container *ngIf="viewConfig.noData">
        <div class="col-md-12">
          <ngb-alert (closed)="viewConfig.setDefault()" type="warning">
            No Data Found
          </ngb-alert>
        </div>
      </ng-container>

      <a
        class="doc-search-table-skip"
        href="#document-search-results-table"
        (click)="onSkipToResultsTableClick($event)"
        (keydown.enter)="onSkipToResultsTableKeydown($event)"
        (keydown.space)="onSkipToResultsTableKeydown($event)"
      >
        Skip to document search results table
      </a>
      <div id="main" class="table-responsive-sm">
        <table
          id="document-search-results-table"
          class="table ind-table table-hover"
          tabindex="-1"
        >
          <caption class="visually-hidden">
            Document search results
          </caption>
          <thead class="ind-table-thead">
            <tr>
              <th scope="col" id="doc-search-col-filename">File Name</th>
              <th scope="col" id="doc-search-col-pages">Pages</th>
              <th scope="col" id="doc-search-col-bucket">Bucket</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let document of documents;
                let i = index;
                trackBy: trackDocument
              "
            >
              <th
                scope="row"
                [attr.id]="'doc-search-row-' + i"
                headers="doc-search-col-filename"
              >
                <a
                  [attr.href]="getDocumentHref(document)"
                  (click)="openDocumentFromUserEvent($event, document)"
                  (keydown.enter)="onDocumentLinkActivateKeydown($event, document)"
                  (keydown.space)="onDocumentLinkActivateKeydown($event, document)"
                  [attr.aria-label]="
                    'Go to document ' + document.name + ', sequence ' + document.seqNumber
                  "
                >
                  {{ document.name }}
                </a>
              </th>
              <td [attr.headers]="'doc-search-col-pages doc-search-row-' + i">
                {{ document.totalPages }}
              </td>
              <td [attr.headers]="'doc-search-col-bucket doc-search-row-' + i">
                {{ document.bucketName }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="ind-table-pagination">
        <div class="row">
          <div class="col-6">
            <label for="pageSize" class="visually-hidden">Page Size</label>
            <select
              id="pageSize"
              [attr.aria-label]="'Page Size'"
              class="ind-table-entries"
              [(ngModel)]="pageSize"
              (ngModelChange)="refreshData()"
            >
              <option *ngFor="let pageSize of allPageSizes" [value]="pageSize">
                {{ pageSize }} entries
              </option>
            </select>
          </div>
          <div class="col-6">
            @if (collectionSize) {
            <div class="d-flex justify-content-end mb-2">
              <small class="p-1">
                <span *ngIf="collectionSize > 0">
                  Showing {{ (page - 1) * pageSize + 1 }} -
                  {{
                    page * pageSize > collectionSize
                      ? collectionSize
                      : page * pageSize
                  }}
                  entries of {{ collectionSize }}
                </span>
                <span *ngIf="collectionSize === 0">
                  No entries to display.
                </span></small
              >
              <ngb-pagination
                class="d-flex justify-content-end"
                size="sm"
                [maxSize]="2"
                [collectionSize]="collectionSize"
                [(page)]="page"
                [pageSize]="pageSize"
                (pageChange)="refreshData()"
                aria-label="Pagination navigation"
              ></ngb-pagination>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
